import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getStoredAuth } from '../api/client';

const AdminRoute: React.FC = () => {
  const { token, user } = getStoredAuth();

  if (!token || !user || user.role !== 'admin') {
    return <Navigate to="/member/login" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
